import React from 'react';
import Animated, { FadeIn, FadeOut } from 'react-native-reanimated';
import { Box } from 'native-base';
const AnimatedBox = Animated.createAnimatedComponent(Box);
export function AnimatedButtonContent({ textTransition, textTransitionDuration, text, children, autoWidth, autoButtonPadding, }) {
    const textTransitionProps = textTransition
        ? {
            key: text,
            entering: FadeIn.duration(textTransitionDuration),
            exiting: FadeOut.duration(textTransitionDuration),
        }
        : {};
    return (React.createElement(AnimatedBox, { key: textTransitionProps.key, entering: textTransitionProps.entering, exiting: textTransitionProps.exiting, flexDirection: 'row', justifyContent: 'center', alignItems: 'center', px: autoWidth ? autoButtonPadding : 2, py: 1 }, children));
}
